"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));
var _MessageContext = _interopRequireDefault(require("../../../context/MessageContext"));
var _ShopContext = _interopRequireDefault(require("../../../context/ShopContext"));
var _ProductDetailContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductDetailContext"));
var _ProductSelectionContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductSelectionContext"));
var _useAddToCartDisabled = _interopRequireDefault(require("../../../ProductDetail/hooks/useAddToCartDisabled"));
var _addItem = _interopRequireWildcard(require("../../../utils/cart/addItem"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _CartButton = _interopRequireDefault(require("./CartButton.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LoadingIcon = (0, _component.default)(() => import("../../../components/LoadingIcon"));
const CartButton = _ref => {
  let {
    displayedAttributes = [],
    lang = "de",
    onAdded
  } = _ref;
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    setCart,
    setOpenCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    setMessageObj
  } = (0, _react.useContext)(_MessageContext.default);
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    productSelection
  } = (0, _react.useContext)(_ProductSelectionContext.default);
  const [loading, setLoading] = (0, _react.useState)(false);
  const isAddToCartDisabled = (0, _useAddToCartDisabled.default)({
    displayedAttributes
  });
  const startDate = (0, _react.useRef)(null);
  const css = (0, _CartButton.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const handleClick = async () => {
    startDate.current = new Date();
    setLoading(true);
    const response = await (0, _addItem.default)({
      product: productDetailData,
      params: productSelection,
      shop: shopData
    });
    const {
      msg
    } = response || {};
    const endDate = new Date();
    const differenceToOneSecond = 500 - (endDate.getTime() - startDate.current.getTime());
    const timer = differenceToOneSecond > 0 ? differenceToOneSecond : 0;
    if (!msg) {
      localStorage.setItem("mco-shop-cart", JSON.stringify(response));
      setCart(response);
    }
    if (onAdded) onAdded();
    setLoading(false);
    setTimeout(() => {
      if (msg) {
        setMessageObj({
          message: l("reactShop.messages.errors.".concat(_addItem.ADD_ITEM_ERRORS[msg])),
          type: "error"
        });
      } else {
        setMessageObj({
          message: l("reactShop.messages.success.CART_ITEM_ADDED"),
          type: "success"
        });
        if (!onAdded) setOpenCart(true);
      }
    }, timer);
  };
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.cartButton, "mco-shop-product-detail-cart-button", {
      [css.isLoading]: loading,
      [css.isDisabled]: isAddToCartDisabled || loading
    }),
    color: "primary",
    fullWidth: true,
    variant: "contained",
    onClick: handleClick
  }, loading ? /*#__PURE__*/_react.default.createElement(LoadingIcon, null) : /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.productDetail.buttons.cart",
    l: l
  }));
};
CartButton.propTypes = {
  displayedAttributes: _propTypes.default.array,
  lang: _propTypes.default.string,
  onAdded: _propTypes.default.func
};
var _default = exports.default = CartButton;